import { render, staticRenderFns } from "./ExtendedRadioGroup.vue?vue&type=template&id=4b2cae82&scoped=true&"
import script from "./ExtendedRadioGroup.vue?vue&type=script&lang=js&"
export * from "./ExtendedRadioGroup.vue?vue&type=script&lang=js&"
import style0 from "./ExtendedRadioGroup.vue?vue&type=style&index=0&id=4b2cae82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2cae82",
  null
  
)

export default component.exports